// extracted by mini-css-extract-plugin
export default {"container":"Funnel_container__Y+ga+"};